import styled from 'styled-components';

import { breakpoints } from '@notino/react-styleguide-v20';

import { Bold } from '@styles/generalStyles';

export const StyledGeneralTextService = styled.div`
  display: inline;
`;

export const StyledTitleExtended = styled.span`
  display: none;

  @media (min-width: ${breakpoints.md}) {
    padding-left: 0.3125rem;
    display: inline;
  }
`;

export const StyledTitle = styled(Bold)`
  display: inline;
`;
